
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premier-agent/category/[...slug]",
      function () {
        return require("private-next-pages/premier-agent/category/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premier-agent/category/[...slug]"])
      });
    }
  